import BaseServiceHttp from '../baseService'
class Relatorios extends BaseServiceHttp {
  constructor(id) {
    const resource = 'relatorios/gestao-leitura'
    const relationship = {
      ProcessaLeituras: 'processa-leituras'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Relatorios(id)
